export const kpNotice = {
  warning: (position, time, text) => {
    // console.log('this.$vux', window.vm.$vux, window.vm.$store)
    window.vm.$vux.toast.show({
      text: text,
      type: 'warn',
      width: '250px',
      position: position,
      time: time
    })
  }
}



// WEBPACK FOOTER //
// ./src/util/notice.js